// extracted by mini-css-extract-plugin
export default {"wrapper":"ABBXBO","button":"hQLH3i"};